module.exports = __webpack_public_path__ + "img/img010.916321fb.png";